import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base.component';
import { SidebarService } from '@core/services/sidebar.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent extends BaseComponent implements OnInit {
  isCollapsed = false;
  isMobileOpen = false;

  constructor(
    private router: Router,
    public sidebarService: SidebarService
  ) {
    super();
  }

  ngOnInit(): void {
    this.sub$.sink = this.sidebarService.isCollapsed$.subscribe(
      (collapsed) => (this.isCollapsed = collapsed)
    );
    this.sub$.sink = this.sidebarService.isMobileOpen$.subscribe(
      (mobileOpen) => (this.isMobileOpen = mobileOpen)
    );
  }

  closeSidebar(): void {
    this.sidebarService.closeMobile();
  }
}
